module.exports = __webpack_public_path__ + "img/NicolasRman.2479d01f.jpg";